import React from 'react';
import ReactDOM from 'react-dom'
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl";
import moment from 'moment';
import {withAuthorization} from "../../../services/Authorization";
import Constants from "../../../services/Constants";
import SafesPlanningTable from "./SafesPlanningTable";
import SafeInfoModal from "./SafeInfoModal";
import {Modal} from "antd";
import AssignedSafesDetail from "./AssignedSafesDetail";
import './SafesPlanning.css'

class SafesPlanning extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      safesPlanning: [],
      //page: 1,
      //size: 10,
      from: moment().format(Constants.DATE_FORMAT_API),
      to: moment().add(7, 'days').format(Constants.DATE_FORMAT_API),
      safeInformationModalVisible: false,
    }
    this.setLabelListRef = element => {
      this.labelList = ReactDOM.findDOMNode(element);
    };

  }

  componentDidMount(){
    window.onLabelLoaded = (doc) => {
      doc.getElementById('printDailySafeDetailsDiv').appendChild(this.labelList.cloneNode(true));
    };

  }

  handleOnPrint = () => {
    let iframe = document.getElementById('printFrame');
    iframe.contentWindow.print();
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchSafesPlanning && nextProps.fetchSafesPlanning.safesPlanning) {
      this.setState({safesPlanning: nextProps.fetchSafesPlanning.safesPlanning});
    }
  };

  fetchSafesPlanning = (page, size, from, to) => {
    this.setState({from, to});
    this.props.dispatchFetchSafesPlanning({from, to});
  };

  onDataUpdate = (page, size, from, to) => {
    this.fetchSafesPlanning(page, size, from, to);
  };

  onUserInfoModalOpen = (availability) => {
    if (availability.safeStatus === 'ASSIGNED') {
      this.setState({safeInformationModalVisible: true, selectedSafe: availability})
    }
  };

  onUserInfoModalClose = () => {
    this.setState({safeInformationModalVisible: false})
  };

  onDailyPlanningClick = () => {
    this.setState({showPrintModal:true})
  };


  render() {
    const {intl: {formatMessage}, fetchSafesPlanning: {loading, totalElements, error = {}}} = this.props;
    const {safesPlanning, from, to, safeInformationModalVisible, selectedSafe, showPrintModal} = this.state;
    const errors = error.content || {};

    const dailySafePlanning = safesPlanning
      .filter(sp=>{
        const todayAvailability = sp.availabilities[this.state.from];
        return todayAvailability && todayAvailability.safeStatus === 'ASSIGNED';
      })
      .map(sp=>{
        return {availability:sp.availabilities[this.state.from], dealerSafe: sp.dealerSafe}
      });

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.safes-planning.title'})}
          </h2>
          <div className="box-heading__right">
            <button onClick={this.onDailyPlanningClick} disabled={!dailySafePlanning || dailySafePlanning.length === 0} type="primary" className="btn btn-sm btn-primary right print-btn">{formatMessage({id:'section.daily-planning.title'})}</button>
          </div>
        </header>
        <div className="box__body">
          <SafesPlanningTable loading={loading} from={from} to={to} error={errors} totalElements={totalElements}
                              safesPlanning={safesPlanning} onDataUpdate={this.onDataUpdate} onSelect={this.onUserInfoModalOpen} hideTo={true}/>

          <SafeInfoModal visible={safeInformationModalVisible} onModalClose={this.onUserInfoModalClose} safeInfo={selectedSafe}/>
        </div>
        <Modal closable={false} visible={showPrintModal} width={'80%'} onCancel={()=>this.setState({showPrintModal:false})}
               className={"daily-safe-planning-modal"}
               footer={[
                 <button key="print" type="primary" className="btn btn-sm btn-primary hide-print" onClick={()=>this.handleOnPrint()}>{formatMessage({id: 'action.print'})}</button>
               ]}>
          <div className={"row"} ref={this.setLabelListRef} >
          {dailySafePlanning.map((sp, index)=>{
              return <AssignedSafesDetail
                pageBreak={(index !== 0 && (index+1)%6 === 0)}
                safe={sp.dealerSafe}
                type={sp.type}
                details={sp.availability}/>
            })
          }
          </div>
          <iframe id="printFrame" name="printFrame" className="printFrame" src="/print/daily-safe-details"></iframe>

        </Modal>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchSafesPlanning: state.fetchSafesPlanning
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchSafesPlanning: (params) => dispatch({type: 'FETCH_SAFES_PLANNING.REQUEST', params})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(SafesPlanning), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/safes/planning/SafesPlanning.js